<script context="module">
    import { env } from '../Environment.svelte';

    const VERIFICATION_CODE_BASE_URL = `${env[env.stage].api.url}apikey/izzi/ms/purchaseServices/sales`;
    const VERIFICATION_CODE_API_KEY = `${env[env.stage].api.key}`;

    const headers = {
        'Content-Type': 'application/json',
        'x-access-origin': 'IZZI',
        'x-access-channel': 'PORTALVL',
        'x-api-key': VERIFICATION_CODE_API_KEY,
    };

    function buildRequestOptions(payload) {
        return {
            method: 'POST',
            headers,
            body: JSON.stringify(payload),
        };
    }

    function assertSuccess(response) {
        if (response.izziErrorCode !== '000') {
            const error = new Error(
                `Error ${response.izziErrorCode}: ${response.izziError}`
            );
            error.code = response.izziErrorCode;
            error.details = response.izziError;
            throw error;
        }
    }

    export async function sendPaymentUrl(store) {
        const payload = {
            correo: store.personalDetails.correo,
            telefono: Number(store.personalDetails.numeroCelular),
            rpt: store.requestedAddress.addressRPT || '000',
            exencion: false,
            monto: store.requestedServices.total,
            cuenta: store.purchaseStatus.accountNumber,
            oferta: 'IZZI',
            canal: 'WEB',
        };

        try {
            const response = await fetch(
                `${VERIFICATION_CODE_BASE_URL}/envioLigaPago`,
                buildRequestOptions(payload)
            );

            const json = await response.json();
            assertSuccess(json);
            return json;
        } catch (error) {
            console.error('Failed to send payment URL:', error);
            throw error;
        }
    }

    export async function validatePaymentComplete(store) {
        const payload = {
            referencia: store.purchaseStatus.paymentReference,
            cuenta: store.purchaseStatus.accountNumber,
        };

        try {
            const response = await fetch(
                `${VERIFICATION_CODE_BASE_URL}/verificaPago`,
                buildRequestOptions(payload)
            );

            const json = await response.json();
            assertSuccess(json);
            return json;
        } catch (error) {
            console.error('Failed to validate payment:', error);
            throw error;
        }
    }
</script>
